export default {
    statusUpdated: false,
    buyoutItemsFormIsSubmitted: false,
    customerFormIsSubmitted: false,
    customerFormIsVisible: false,
    isContractPreviewVisible: false,
    isEmail: true,
}